angular.module('tgaAdmin').controller('HubSpinModalController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'customFieldService',
  'extras',
  '$translate',
  function ($scope, $state, $window, $uibModalInstance, $uibModalStack, customFieldService, extras, $translate) {
    $scope.data = {
      alerts: [],
      closeButton: extras.closeButton,
      frequency: [
        {
          name: 'Daily',
          id: 'daily',
        },
        {
          name: 'Weekly',
          id: 'weekly',
        },
        {
          name: 'Monthly',
          id: 'monthly',
        },
      ],
    };

    $scope.viewmodel = {
      frequency: null,
      prize_list_id: null,
    };
    $scope.loading = false;

    $scope.initialize = function () {
      $scope.loading = false;
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
